import React from "react";

interface Props {
    size?: number;
    color?: string;
}

export const DispositionIcon = (props: Props) => {
    const size = props.size ?? 20;
    const color = props.color ?? "var(--color-purple-400)";

    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.3265 8.08923L6.64648 4.23706"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.6668 12.9873V7.04951C16.6665 6.78919 16.5978 6.53352 16.4675 6.30814C16.3372 6.08277 16.15 5.89561 15.9245 5.76545L10.7289 2.79654C10.5033 2.66625 10.2473 2.59766 9.9867 2.59766C9.72613 2.59766 9.47014 2.66625 9.24447 2.79654L4.04887 5.76545C3.82343 5.89561 3.63618 6.08277 3.5059 6.30814C3.37563 6.53352 3.30691 6.78919 3.30664 7.04951V12.9873C3.30691 13.2477 3.37563 13.5033 3.5059 13.7287C3.63618 13.9541 3.82343 14.1412 4.04887 14.2714L9.24447 17.2403C9.47014 17.3706 9.72613 17.4392 9.9867 17.4392C10.2473 17.4392 10.5033 17.3706 10.7289 17.2403L15.9245 14.2714C16.15 14.1412 16.3372 13.9541 16.4675 13.7287C16.5978 13.5033 16.6665 13.2477 16.6668 12.9873Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.50586 6.27759L9.98552 10.0258L16.4652 6.27759"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.98633 17.5V10.0183"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
